import { Avatar, Col, Row, Text } from 'ui';

type P = {
  email: string;
  name: string;
  photo: string;
};

// TODO: move to ui
const AvatarOption = ({ email, name, photo }: P) => (
  <Row align="middle" gutter={['ms', 0]}>
    <Col>
      <Avatar photo={photo} size="small" />
    </Col>
    <Col flex="1">
      <Row>
        <Col span={24}>
          {/* TODO: should be primary color, check it with designers */}
          <Text type="title">{name}</Text>
        </Col>
        <Col span={24}>
          <Text size="small" type="secondary">
            {email}
          </Text>
        </Col>
      </Row>
    </Col>
  </Row>
);

export default AvatarOption;
